import Type from "@/model/types/Type";

const type = {
    ITEM: 1,
    KIT: 2,
}

const list = [
    {
        value: type.ITEM,
        text: "Item",
    },
    {
        value: type.KIT,
        text: "Kit",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}